import React from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import { toNumber } from '@/document-entry/format';

function formatThousandsInput(value: string): string {
  const digits = value.replace(/\D/g, '');
  if (!digits) return '';
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

type PayrollMoneyInputProps = {
  value: number;
  onChange: (value: number) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
};

/** ورودی مبلغ با جداکننده هزارگان هنگام تایپ (مثل 1,234,567) */
const PayrollMoneyInput: React.FC<PayrollMoneyInputProps> = ({
  value,
  onChange,
  className,
  placeholder,
  disabled,
}) => {
  const [text, setText] = React.useState(() => (value > 0 ? formatThousandsInput(String(value)) : ''));

  React.useEffect(() => {
    const formatted = value > 0 ? formatThousandsInput(String(value)) : '';
    if (toNumber(text) !== value) {
      setText(formatted);
    }
  }, [value]);

  return (
    <Input
      className={cn('font-mono text-xs', className)}
      dir="ltr"
      disabled={disabled}
      placeholder={placeholder}
      value={text}
      onChange={(e) => {
        const formatted = formatThousandsInput(e.target.value);
        setText(formatted);
        onChange(toNumber(formatted));
      }}
    />
  );
};

export default PayrollMoneyInput;
